module.exports = __webpack_public_path__ + "img/m-shuijinchaxun.d44800db.svg";